<template>
  <el-row style="text-align: left">
    <el-select v-model="orgSelection" style="width: 100%" filterable :collapse-tags="collapseTags" clearable
      :multiple="multiple" :placeholder="placeholder ? placeholder : 'Select Organizations'" @change="returnSelection">
      <el-option-group v-for="group in filterGroups.filter((group) => {
        if (showOnlySchoolSelector && group.value == 'schools_only') {
          return group;
        } else if (!showOnlySchoolSelector) {
          return group;
        }
      })" :key="group.label" :label="group.label">
        <el-option v-for="item in group.options" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-option-group>
    </el-select>
  </el-row>
</template>
<script>
import ApiService from "@/services/ApiService";
export default {
  name: "filteringMain",
  props: {
    showOnlySchoolSelector: Boolean,
    multiple: Boolean,
    collapseTags: {
      default: true,
      type: Boolean,
    },
    initialSelection: {
      default: () => [],
      type: Array,
    },
    placeholder: String
  },
  data() {
    return {
      orgSelection: [],
      groups: [],
      schools: [],
      filterGroups: [],
      loading: true,
      // accType: "",
      typeSelection: "all",
      termSelection: "CURRENT",
      terms: [],
    };
  },
  computed: {
    accType: function () {
      return this.$store.state.accType;
    },
  },
  methods: {
    returnSelection() {
      if (this.multiple && this.orgSelection.indexOf("all") > -1) {
        this.orgSelection = ["all"];
      }
      let orgs = this.orgSelection;
      // console.log('orgs', orgs);
      const split = typeof orgs[0] === 'string' ? orgs[0]?.split("_") : undefined;
      if (split && orgs[0]?.split("_") && split.length > 1) {
        if (split[0] === "group") {
          orgs = this.groups.find(group => group.id === parseInt(split[1])).organization_ids;
          if (typeof orgs === 'string') {
            orgs = orgs.split(","); // as int array
            orgs = orgs.map(org => parseInt(org));
          }
        }
      }
      this.$emit("return-selection", { organization_id: orgs });
    },
    goto(page) {
      this.$router.push({ name: page });
    },
  },
  mounted() {
    ApiService.generalApi.getOrgsGroupsFiltering().then((response) => {
      const filterGroups = [];
      this.schools = response.data.schools;
      this.groups = response.data.groups;
      const groups = response.data.groups.map((itm) => {
        return {
          id: "group_" + itm.id,
          name: itm.name,
        };
      });
      const councils = response.data.councils.map((itm) => {
        return {
          id: "council_" + itm.id,
          name: itm.name,
        };
      });

      if (this.schools.length > 0) {
        filterGroups.push({
          label: "Schools only",
          value: "schools_only",
          options: this.schools,
        });
      }

      if (groups.length > 0) {
        filterGroups.push({
          label: "GROUPS only",
          options: groups,
        });
      }
      if (councils.length > 0) {
        filterGroups.push({
          label: "Councils",
          options: councils,
        });
      }
      this.filterGroups = filterGroups;

      if (this.initialSelection.length > 0) {
        this.orgSelection = this.initialSelection.map((itm) =>
          isNaN(itm) ? itm : parseInt(itm)
        );
      }
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.block {
  margin-bottom: 8px;
}

.circularButton {
  width: 50px;
  height: 50px;
}
</style>
